import React, { Fragment, useMemo } from "react";

// types
import { DateRange } from "../../../types/common";
import { Origin } from "../../../types/origins";
import { Leader } from "../../../types/leaders";
import { Supervisor } from "../../../types/supervisors";
import { Seller } from "../../../types/sellers";
import { State } from "../../../types/states";
import { Channel } from "../../../types/channels";
import { Client } from "../../../types/clients";
import { OperationType } from "../../../types/operationTypes";


// components
import DateFilters from "./DateFilters.content";
import DateFiltersPanel from "./DateFiltersPanel";
import { useClassicView } from "../../../config/classicView";
import BusinessFilters from "./BusinessFilters/BusinessFilters.container";
import {dateToShortDateString, getDefaultDates} from "../../../utils/functions";

interface Props {
  // Date Filters
  rangeDate: DateRange;
  setRangeDate: (rangeDate: DateRange) => void;
  // Business Filters
  idSourceFilter: string;
  setIdSourceFilter: (value: string) => void;
  originsSelected: Origin[];
  leadersSelected: Leader[];
  supervisorsSelected: Supervisor[];
  sellersSelected: Seller[];
  statesSelected: State[];
  channelsSelected: Channel[];
  clientsSelected: Client[];
  operationTypesSelected: OperationType[];
  setOriginsSelected: (param: Origin[]) => void;
  setLeadersSelected: (param: Leader[]) => void;
  setSupervisorsSelected: (param: Supervisor[]) => void;
  setSellersSelected: (param: Seller[]) => void;
  setStatesSelected: (param: State[]) => void;
  setChannelsSelected: (param: Channel[]) => void;
  setClientsSelected: (param: Client[]) => void;
  setOperationTypesSelected: (param: OperationType[]) => void;
  sendFilters: () => void;
  resetFilters: () => void;
}

export default (props: Props) => {
  const dateParams = useMemo(() => {
    return {
      dateSince: dateToShortDateString(props.rangeDate.start) || getDefaultDates().start,
      dateUntil: dateToShortDateString(props.rangeDate.end) || getDefaultDates().end,
    };
  }, [props.rangeDate]);

  const customFilters = () => {
        return <BusinessFilters
            dateParams={dateParams}
            idSourceFilter={props.idSourceFilter}
            setIdSourceFilter={props.setIdSourceFilter}
            originsSelected={props.originsSelected}
            leadersSelected={props.leadersSelected}
            supervisorsSelected={props.supervisorsSelected}
            sellersSelected={props.sellersSelected}
            statesSelected={props.statesSelected}
            channelsSelected={props.channelsSelected}
            clientsSelected={props.clientsSelected}
            operationTypesSelected={props.operationTypesSelected}
            setOriginsSelected={props.setOriginsSelected}
            setLeadersSelected={props.setLeadersSelected}
            setSupervisorsSelected={props.setSupervisorsSelected}
            setSellersSelected={props.setSellersSelected}
            setStatesSelected={props.setStatesSelected}
            setChannelsSelected={props.setChannelsSelected}
            setClientsSelected={props.setClientsSelected}
            setOperationTypesSelected={props.setOperationTypesSelected}
            sendFilters={props.sendFilters}
            resetFilters={props.resetFilters}
        />
  }

  const { classic } = useClassicView();
  const Dates = classic ? DateFilters : DateFiltersPanel;
  const dates = (
      <Dates
        rangeDate={props.rangeDate}
        setRangeDate={props.setRangeDate}
      />
  );

  return (
    <Fragment>
      {classic && dates}
      {customFilters()}
      {!classic && dates}
    </Fragment>
  );
};
